import { RubricTag } from '@pu/models';

export function getTagsMock(count = 12): RubricTag[] {
  const tags: RubricTag[] = [];

  tags.push({
    id: null,
    name: 'All',
  });

  for (let i = 1; i <= count; i++) {
    tags.push({
      id: i,
      name: `Tag ${i}`,
    });
  }

  return tags;
}
